module.exports = __webpack_public_path__ + "static/media/rain-cloud-weather-2_200_transparent.3830f09d.gif";